<template>
  <font-awesome-icon
    icon="reply"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faReply } from '@fortawesome/free-solid-svg-icons'

library.add(faReply)

export default {
  name: 'CoozzyReplyIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
